export default {
    name: 'areaCascader',
    data() {
      return {
        areaOption: this.$$dataDict.area,
        areaOptValue: [],
      }
    },
   
    model: {
        prop: 'value',
        event: 'change'
    },
    watch: {
      areaOptValue(val, oldVal) { 
        console.log(val)
        this.$emit('change', val);
      },
      value() { 
        this.areaOptValue = this.value;
      }
    },
    props: {
      value: {
        type: Array,
        default:[]
      },
      placeholder: {
        type: String
      },
      clearable: {
        type: Boolean,
        default: true
      },
      emitPath: {
        type: Boolean,
        default: true
      }
    },
    created() {
      this.areaOptValue = this.value;
    },
    methods: {
      getText() { 
        let checkedNode = this.$refs.area.getCheckedNodes();
        if (checkedNode.length > 0) {
          return checkedNode[0].pathLabels;
        } else { 
          return [];
        }
      }
    }
}